<template>
  <a-modal v-model="isShow" title="Search" @ok="onSearchSubmit">
    <div style="padding-right: 10px">
      Name
      <a-input v-model="name" placeholder="" />
      <div style="margin: 10px 0" />

      Building
      <a-input v-model="building" placeholder="" />
      <div style="margin: 10px 0" />

      Floor
      <a-input v-model="floor" placeholder="" />
      <div style="margin: 10px 0" />

      Type
      <a-input v-model="type" placeholder="" />
      <div style="margin: 10px 0" />

      Capacity
      <a-input v-model="capacity" placeholder="" />
      <div style="margin: 10px 0" />

      Allow for booking
      <a-select default-value="Yes" v-model="allowBooking" style="width: 100%">
        <a-select-option value=""> ----- </a-select-option>
        <a-select-option value="Yes"> Yes </a-select-option>
        <a-select-option value="No"> No </a-select-option>
      </a-select>
      <div style="margin: 10px 0" />

      Status
      <a-select default-value="Enable" v-model="status" style="width: 100%">
        <a-select-option value=""> ----- </a-select-option>
        <a-select-option value="Enable"> Enable </a-select-option>
        <a-select-option value="Disable"> Disable </a-select-option>
      </a-select>
      <div style="margin: 10px 0" />

      Remark
      <a-input v-model="remark" placeholder="" />
      <div style="margin: 10px 0" />
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    search: { type: Function }
  },
  components: {},
  data() {
    return {
      //
      name: "", // username
      building: "",
      floor: "",
      type: "",
      capacity: "",
      allowBooking: "",
      status: "",
      remark: "",
      //
      isShow: false
    };
  },
  methods: {
    onSearchSubmit() {
      this.isShow = false;
      this.search({
        name: this.name,
        building: this.building,
        floor: this.floor,
        type: this.type,
        capacity: this.capacity,
        allowBooking: this.allowBooking,
        status: this.status,
        remark: this.remark
      });
    },
    show() {
      this.isShow = true;
    },
    clearFilter() {
      this.name = "";
      this.building = "";
      this.floor = "";
      this.type = "";
      this.capacity = "";
      this.allowBooking = "";
      this.status = "";
      this.remark = "";
    }
  }
};
</script>

<style lang="scss"></style>
